<div class="header" [style.background-image]="header.featuredImage ?
  'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)),url(' + header.featuredImage.url + ')'
  : ''">
  <h1 class="title">{{title}}</h1>
  <h2 class="sub-title">{{header.subTitle}}</h2>
  <div class="info middle">
    <span>{{header.contentType??'Analysis'}}</span>
    <em *ngIf="date" class="vertical-line">|</em>
    <span>{{getDateFormatted()}}</span>
    <em *ngIf="getFilteredCategoryTags().length > 0" class="vertical-line">|</em>
    <span *ngIf="getFilteredCategoryTags().length > 0" class="category-tags">
      <ng-container *ngFor="let tag of getFilteredCategoryTags(); let last = last">
        <a [href]="getCategoryTagUrl(tag)" target="_blank" class="category-tag-link"
          (click)="$event.stopPropagation()">{{tag.name}}</a><span *ngIf="!last">, </span>
      </ng-container>
    </span>
  </div>
  <div class="authors info" *ngIf="header.authors?.length > 0">
    By {{getAuthors()}}
  </div>
</div>